const initialState = [
];

const reduceDataDeviceDetail = (state = initialState, { type, payload }) => {
    switch (type) {
        case "PUSHDATADEVICEDETAIL":
            return payload;
        case "REMOVEDATADEVICEDETAIL":
            return [];
        default:
            return state;
    }
};

export default reduceDataDeviceDetail;
